'use client';

import React, { useEffect } from 'react';

import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import GeneralLoader from '@components/ui/GeneralLoader';
import { useAppRouter } from '@contexts/router';

type LoaderMeta = { showGlobalLoader?: boolean };

const includeInGlobalLoader = (meta?: LoaderMeta) =>
  meta?.showGlobalLoader === true;

interface GlobalNetworkLoaderProps {
  shouldScroll?: boolean;
}

const GlobalNetworkLoader: React.FC<GlobalNetworkLoaderProps> = ({
  shouldScroll = true,
}) => {
  const activeQueryCount = useIsFetching({
    predicate: (q) => includeInGlobalLoader(q.meta as LoaderMeta),
  });

  const activeMutationCount = useIsMutating({
    predicate: (m) => includeInGlobalLoader(m.options?.meta as LoaderMeta),
  });

  const { isLoading: isRouteLoading } = useAppRouter();

  const hasNetworkActivity = activeQueryCount + activeMutationCount > 0;
  const isVisible = hasNetworkActivity || isRouteLoading;

  useEffect(() => {
    if (!shouldScroll) {
      document.body.style.overflow = isVisible ? 'hidden' : '';
      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [isVisible, shouldScroll]);

  if (!isVisible) return null;

  return <GeneralLoader shouldScroll={shouldScroll} />;
};

export default GlobalNetworkLoader;
